import React, { useState, useEffect } from 'react'
import { Share } from '@capacitor/share';
import { Capacitor } from '@capacitor/core';
import axios from 'axios';
import { ShareAltOutlined } from '@ant-design/icons';
import Loader from '../components/Loader';
import JidoItem from '../components/JidoItem';

const Jido = () => {
    const [apidata, setApiData] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getApidata()
    }, [])

    const getApidata = async () => {
        axios.get(`/jido?acf_format=standard&per_page=99`)
            .then((response) => {
                setApiData(response.data)
                scrollToSectionIfIdPresent();
                setLoading(false)
            })
    }

    const scrollToSectionIfIdPresent = () => {
        const hash = window.location.hash;
        if (hash) {
            const element = document.getElementById(hash.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    const handleShare = async (imageUrl) => {
        console.log(imageUrl);

        try {
            // Check if the Web Share API supports sharing files (for web)
            if (!Capacitor.isNativePlatform() && navigator.canShare) {
                // On web: fetch the image as a blob and share it as a File
                const response = await fetch(imageUrl);
                const blob = await response.blob();
                const file = new File([blob], 'yancha-nip.jpg', { type: 'image/jpeg' });

                if (navigator.canShare({ files: [file] })) {
                    await navigator.share({
                        title: 'Yancha Jido Nip',
                        text: 'Check out this Yancha Jido Nip!',
                        files: [file],
                    });
                } else {
                    // Fallback: share just the URL if file sharing is not supported
                    await navigator.share({
                        title: 'Yancha Jido Nip',
                        text: 'Check out this Yancha Jido Nip!',
                        url: imageUrl,
                    });
                }
            } else {
                // On native (Android/iOS): use Capacitor Share plugin
                await Share.share({
                    title: 'Yancha Jido Nip',
                    text: 'Check out this Yancha Jido Nip!',
                    url: imageUrl,
                    dialogTitle: 'Share this Nip',
                });
            }

            console.log('Share successful');
        } catch (error) {
            // User cancelled the share dialog — not an actual error
            if (error.name === 'AbortError') {
                console.log('Share cancelled by user');
            } else {
                console.error("File sharing failed", error.message);
            }
        }
    };

    return (
        <>
            {
                loading ? <Loader /> :
                    <>
                        <div>
                            <div className="bottom15px">
                                <p className='brand-text gradient-heading'>
                                    Forge Your Own Path With Grace & Uniqueness
                                </p>
                            </div>
                            <div className="spacer">
                                <p className='brand-text txt-survey'>
                                    Feelings are understood only when they are shared. Communicate with those who matter using the Yancha Jido Nips. Share it, feel it and connect, because it matters.
                                </p>
                            </div>

                            {
                                apidata.map((data, index) => (
                                    <div className='block bottom15px' id={data.slug} key={data.slug}>
                                        <div className='bottom7px flex flex-row justify-between'>
                                            <p>Nip #{index + 1} </p>
                                            <button onClick={() => handleShare(data.acf.share_image_jido, data.slug)}><span className='mr-2'><ShareAltOutlined /></span>Share this Nip</button>
                                        </div>
                                        <JidoItem jidodata={data} />
                                    </div>
                                ))
                            }

                        </div>
                    </>
            }

        </>
    )
}

export default Jido